export const SET_GROUP = 'GROUP/SET_GROUP'
export const SET_GROUPS = 'GROUP/SET_GROUPS'
